/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CallCenterIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Call Center',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31.091 14h-1.455A11.823 11.823 0 0 0 18 2 11.823 11.823 0 0 0 6.364 14H4.909A2.956 2.956 0 0 0 2 17v6a2.956 2.956 0 0 0 2.909 3h4.364V14H9.2A8.94 8.94 0 0 1 18 4.925 8.94 8.94 0 0 1 26.8 14h-.073v11.338a10.184 10.184 0 0 1-6.21 4.802A3.116 3.116 0 0 0 18 29c-1.607 0-2.909 1.007-2.909 2.25S16.393 33.5 18 33.5a2.789 2.789 0 0 0 2.86-1.87A11.682 11.682 0 0 0 28.054 26h3.036A2.956 2.956 0 0 0 34 23v-6a2.956 2.956 0 0 0-2.909-3Z"
    />
  </svg>`;
};
